import { VariableI } from "./variable";
import { VarParamI } from "./VariableParametrica";

export class FuenteVariableI{
    id : BigInteger;
    fuente : any;
    parametrica : VarParamI;
    variable : VariableI;
    obligatoria : Boolean;
}